import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import SnGrid from "@shared/components/Grid/SnGrid"; // 그리드 공통
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface 현재 오픈된 메뉴의 메뉴 정보 (CD_MENU, NM_MENU, CD_MODULE...)
import SnButton from "@shared/components/SnButton";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_BAS_REG_006 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Variable
  const gridApiRef = useRef<any>(null); // 그리드 Reference 변수
  const searchRef = useRef<any>(null);
  //#endregion

  //#region useState
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);

  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [dataSource, setDataSource] = useState<any[]>([]); // gridApiRefH datasource 관련
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource([]);
      try {
        const rtn: any = await getInitFormData();

        setFormData(rtn.formData); // 조회조건 초기값
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setColums(rtn.grid.grid1); // H그리드 항목 설정
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridApiRef.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region onSearch
  const onSearch = async () => {
    const modifiedRows = gridApiRef.current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const formData = searchRef.current.getFormdata();
      const yyyy = formData.ym.substring(0, 4) + "00";
      const params = { ...formData };
      params.ym = yyyy;

      const param = {
        id: "sn_mtl_bas_reg_006_01",
        params: params,
      };
      setDataSource([]);
      const data: any = await fnGetDataSet(param);
      setDataSource(data[0]);

      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridApiRef.current.selectAndFocusRow(0);
        setGridFocus(true);
      }
      gridApiRef.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onInsert
  const onInsert = () => {
    //gridApiRef.current.addRow();
  };
  //#endregion

  //#region onDelete
  const onDelete = async () => {
    //gridApiRef.current?.deleteSelectedRows();
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      gridApiRef.current.api.stopEditing();
      const requiredValuesCheckL = gridApiRef.current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const changesRow = gridApiRef.current.getChange();
      const SaveData = {
        mtl_aminventory: changesRow,
      };

      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      await fnSave("SN_MTL_BAS_REG_006_SAVE_01", SaveData);
      gridApiRef.current.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region calculateAmounts
  // 계산식 함수
  const calculateAmounts = (row: any) => {
    const qt_inv = row.qt_inv ?? 0;
    const um_inv = row.um_inv ?? 0;

    row.am_inv = qt_inv * um_inv;
  };

  const onCellValueChanged = async (event: any) => {
    if (!event) return;

    const updatedRow = event.data;

    // 수정된 컬럼 ID 및 정보
    const updatedColumnId = event.column.getColId(); // 수정된 컬럼의 ID
    const updatedColumnDef = event.colDef; // 수정된 컬럼의 정의

    if (updatedColumnId === "qt_inv" || updatedColumnId === "um_inv") {
      calculateAmounts(updatedRow);
    }
  };
  //#endregion

  //#region onGrid1BtnsClick
  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnProcess") {
      try {
        if (dataSource && dataSource.length == 0) {
          await showDialog("alter", "재고이월 할 데이터가 없습니다.");
          return;
        }

        // 1. ym이 차기년도 + "00" 인 데이터 조회
        const formData = searchRef.current.getFormdata();
        const yyyy = formData.nexty.substring(0, 4) + "00";
        const params = { ...formData };
        params.ym = yyyy;

        const param = {
          id: "sn_mtl_bas_reg_006_01",
          params: params,
        };
        const nextyData: any = await fnGetDataSet(param);

        // 2. 데이터가 없으면 그냥 insert / 조회 데이터가 있으면 confirm 후 delete & insert
        const saveData = {
          mtl_aminventory: {
            nexty: formData.nexty.substring(0, 4),
            insert: dataSource,
            delete: [],
          },
        };

        if (nextyData.length == 0) {
          await fnSave("SN_MTL_BAS_REG_006_SAVE_02", saveData);
        } else {
          const confirm = await showDialog(
            "confirm",
            "이미 이월처리된 데이터가 있습니다. 기존 데이터 삭제 후 다시 추가하시겠습니까?"
          );
          if (confirm) {
            // saveData.mtl_aminventory.delete = nextyData[0];
            saveData.mtl_aminventory.delete = nextyData[0];
            await fnSave("SN_MTL_BAS_REG_006_SAVE_02", saveData);
          }
        }
        gridApiRef.current.resetUpdate();
      } catch (error: any) {}
    }
  };
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnGrid
          ref={gridApiRef}
          seq={1}
          // enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource}
          // enableExternalChart={false}
          isEditable={true}
          rowSelection="single"
          title="상세정보"
          onCellValueChanged={onCellValueChanged}
          header={
            <div>
              <SnButton
                text={"이윌처리"}
                onClick={() => {
                  onGrid1BtnsClick("btnProcess");
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});
export default SN_MTL_BAS_REG_006;
